import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=6ea13581&scoped=true&"
import script from "./contents.vue?vue&type=script&lang=js&"
export * from "./contents.vue?vue&type=script&lang=js&"
import style0 from "./contents.vue?vue&type=style&index=0&id=6ea13581&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea13581",
  null
  
)

export default component.exports